import useSourceFlowCollection from "@/hooks/useSourceFlowCollection";
import data from "@sourceflow/services.json";

export const useServices = () => useSourceFlowCollection(data);

export default useServices;
